import { useGetAllOrganizations } from '_api';
import { useDeleteOrganization } from '_api/mutations/organizations';
import { Organization } from '_api/types';
import { useMemo } from 'react';

import useUser from './useUser';

const useOrganizations = ({
  page = 0,
  size = 1000,
}: { page?: number; size?: number } = {}) => {
  const { isSuperAdmin } = useUser();

  var allOrganizations: Organization[] | undefined;
  var isLoading: boolean = false;
  if (isSuperAdmin) {
    const { data, isFetching } = useGetAllOrganizations({
      page,
      size,
    });
    allOrganizations = data;
    isLoading = isFetching;
  } else {
    allOrganizations = [];
  }

  const activeOrganizations =
    allOrganizations &&
    !isLoading &&
    allOrganizations.filter((x) => x.status === 'ACTIVE');

  const archiveOrganizations =
    allOrganizations &&
    !isLoading &&
    allOrganizations.filter((x) => x.status === 'DELETED');

  const { mutateAsync: deleteOrganization } = useDeleteOrganization();

  const organizationOptions = useMemo(
    () =>
      activeOrganizations
        ? activeOrganizations.map((org) => ({
            description: org.name,
            name: org.id,
          }))
        : [],
    [activeOrganizations],
  );

  return {
    allOrganizations,
    activeOrganizations,
    archiveOrganizations,
    organizationOptions,
    isLoading,
    deleteOrganization,
  };
};

export default useOrganizations;
